/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {PartNumberChangeCancelCommandModel} from './part-number-change-cancel-command.model';
import {PartNumberChangeCancelCommandContract} from '../../../api/ms-partnumberchanges/contracts/part-number-change-cancel-command.contract';
import {toBase64Utf16LittleEndian} from '../../../shared/utils/encode/encodeToBase64Utf16LE';

/**
 * Utility class to map to and from {@link PncTypeModel}
 */
export class PartNumberChangeCancelCommandMapper {
    private constructor() {
    }

    static fromPartNumberChangeCancelCommandContract(input: PartNumberChangeCancelCommandContract): PartNumberChangeCancelCommandModel {
        return {
            cancellationReason: toBase64Utf16LittleEndian(input?.cancellationReason)
        };
    }

    static toPartNumberChangeCancelCommandContract(input: PartNumberChangeCancelCommandModel): PartNumberChangeCancelCommandContract {
        return {
            cancellationReason: toBase64Utf16LittleEndian(input.cancellationReason)
        };
    }
}
